import { TabSection } from '@quicktools/shared-components';
import { useTranslation } from 'react-i18next';

function TabbedSection() {
  const { t } = useTranslation();

  const imgagesAlt = [
    {
      imgAlt: 'complementary color combinations',
      imgUrl: 'https://cdn140.picsart.com/91600287710791865953.png',
    },
    {
      imgAlt: 'monochromatic color combinations',
      imgUrl: 'https://cdn140.picsart.com/01941665044431593148.png',
    },
    {
      imgAlt: 'analogous color combinations',
      imgUrl: 'https://cdn140.picsart.com/12517116092066911815.png',
    },
    {
      imgAlt: 'triadic color combinations',
      imgUrl: 'https://cdn140.picsart.com/93353304934789042380.png',
    },
  ];

  const tabs = Array.from(imgagesAlt).map(({ imgUrl, imgAlt }, index) => ({
    title: t(`landing.tabbedSection.tabs.${index}.name`),
    description: t(`landing.tabbedSection.tabs.${index}.paragraph`),
    imgAlt,
    imgUrl,
  }));

  return (
    <TabSection
      items={tabs}
      titleElement="h2"
      title={t('landing.tabbedSection.title')}
      subtitle={t('landing.tabbedSection.description')}
    />
  );
}

export default TabbedSection;
